var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{staticClass:"elevation-0",attrs:{"color":"secondary"}},[_c('v-toolbar-title',[_vm._v(" Instances ")])],1),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"disable-sort":"","dense":"","disable-pagination":"","hide-default-footer":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }